import React from 'react';
import BookOfBusinessTable from 'components/book-of-business/BookOfBusinessTable';
import { NoSidebarPageLayout } from '@insurancemenu/imenu-components-lib';

const BookOfBusinessPage: React.FC = () => {
  return (
    <NoSidebarPageLayout
      pageHeader={{
        title: 'Book Of Business',
        subtitle: 'Here you have the ability to browse all Summary Files',
      }}
      contentWidth="standard"
    >
      <BookOfBusinessTable />
    </NoSidebarPageLayout>
  );
};

export default BookOfBusinessPage;
